import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "h-full flex bg-white text-black" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-600 bg-opacity-75" }, null, -1)
const _hoisted_3 = { class: "fixed inset-0 flex z-40" }
const _hoisted_4 = { class: "absolute top-0 right-0 -mr-12 pt-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close sidebar", -1)
const _hoisted_6 = { class: "flex-1 h-0 pt-5 pb-4 overflow-y-auto" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0 flex items-center px-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-8 w-auto",
    src: "https://res.cloudinary.com/mirrorworld/image/upload/v1657222413/launchpads/20220708-033216_w7qf45.png",
    alt: "Workflow"
  })
], -1)
const _hoisted_8 = {
  "aria-label": "Sidebar",
  class: "mt-5"
}
const _hoisted_9 = { class: "px-2 space-y-1" }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0 flex border-t border-gray-200 p-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "flex-shrink-0 group block"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("img", {
          class: "inline-block h-10 w-10 rounded-full",
          src: "https://res.cloudinary.com/mirrorworld/image/upload/v1657222413/launchpads/20220708-033216_w7qf45.png",
          alt: ""
        })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "text-base font-medium text-gray-700 group-hover:text-gray-900" }, "Mirror World"),
        /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-gray-500 group-hover:text-gray-700" }, " SDK Admin ")
      ])
    ])
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex-shrink-0 w-14",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_13 = { class: "hidden lg:flex lg:flex-shrink-0 relative" }
const _hoisted_14 = { class: "flex flex-col w-64" }
const _hoisted_15 = { class: "flex-1 flex flex-col min-h-0 border-r border-gray-200 bg-gray-100" }
const _hoisted_16 = { class: "flex-1 flex flex-col pt-5 pb-4 overflow-y-auto" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center flex-shrink-0 px-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-8 w-auto",
    src: "https://res.cloudinary.com/mirrorworld/image/upload/v1657222413/launchpads/20220708-033216_w7qf45.png",
    alt: "Workflow"
  })
], -1)
const _hoisted_18 = {
  class: "mt-5 flex-1",
  "aria-label": "Sidebar"
}
const _hoisted_19 = { class: "px-2 space-y-1" }
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-shrink-0 flex border-t border-gray-200 p-4\"><a href=\"#\" class=\"flex-shrink-0 w-full group block\"><div class=\"flex items-center\"><div><img class=\"inline-block h-9 w-9 rounded-full\" src=\"https://res.cloudinary.com/mirrorworld/image/upload/v1657222413/launchpads/20220708-033216_w7qf45.png\" alt=\"\"></div><div class=\"ml-3\"><p class=\"text-sm font-medium text-gray-700 group-hover:text-gray-900\">Mirror World</p><p class=\"text-xs font-medium text-gray-500 group-hover:text-gray-700\">SDK Admin</p></div></div></a></div>", 1)
const _hoisted_22 = { class: "flex flex-col min-w-0 flex-1 overflow-hidden" }
const _hoisted_23 = { class: "flex justify-end item-center py-4 px-8 space-x-4" }
const _hoisted_24 = { class: "lg:hidden" }
const _hoisted_25 = { class: "flex items-center justify-between bg-gray-50 border-b border-gray-200 px-4 py-1.5" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-8 w-auto",
    src: "https://res.cloudinary.com/mirrorworld/image/upload/v1657222413/launchpads/20220708-033216_w7qf45.png",
    alt: "Workflow"
  })
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open sidebar", -1)
const _hoisted_28 = { class: "flex-1 relative z-0 flex overflow-hidden" }
const _hoisted_29 = { class: "flex-1 relative z-0 overflow-y-auto focus:outline-none" }
const _hoisted_30 = { class: "absolute inset-0 py-6 px-4 sm:px-6 lg:px-8" }
const _hoisted_31 = { class: "h-full border-2 border-gray-200 border-dashed rounded-lg" }
const _hoisted_32 = {
  key: 0,
  class: "flex flex-col space-y-3 px-3 py-3"
}
const _hoisted_33 = { class: "bg-gray-50 rounded-md px-1 py-1" }
const _hoisted_34 = { class: "relative border border-gray-300 rounded-md px-3 py-2 focus-within:z-10 focus-within:ring-1 focus-within:ring-indigo-600 focus-within:border-indigo-600" }
const _hoisted_35 = {
  for: "name",
  class: "block text-xs font-medium text-gray-900"
}
const _hoisted_36 = ["onUpdate:modelValue", "disabled"]
const _hoisted_37 = { class: "relative border border-gray-300 rounded-md px-3 py-2 focus-within:z-10 focus-within:ring-1 focus-within:ring-indigo-600 focus-within:border-indigo-600" }
const _hoisted_38 = {
  for: "name",
  class: "block text-xs font-medium text-gray-900"
}
const _hoisted_39 = ["onUpdate:modelValue", "disabled"]
const _hoisted_40 = { class: "relative order-first xl:flex xl:flex-col flex-shrink-0 w-96 border-r border-gray-200 overflow-y-auto" }
const _hoisted_41 = { class: "absolute inset-0 py-6 px-4 sm:px-6 lg:px-8" }
const _hoisted_42 = { class: "h-full border-2 border-gray-200 border-dashed rounded-lg flex flex-col space-y-3 p-3" }
const _hoisted_43 = { class: "isolate -space-y-px rounded-md shadow-sm" }
const _hoisted_44 = { class: "relative border border-gray-300 rounded-md rounded-b-none px-3 py-2 focus-within:z-10 focus-within:ring-1 focus-within:ring-indigo-600 focus-within:border-indigo-600" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "block text-xs font-medium text-gray-900"
}, "Program ID", -1)
const _hoisted_46 = { class: "isolate -space-y-px rounded-md shadow-sm" }
const _hoisted_47 = { class: "relative border border-gray-300 rounded-md rounded-t-none px-3 py-2 focus-within:z-10 focus-within:ring-1 focus-within:ring-indigo-600 focus-within:border-indigo-600" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "block text-xs font-medium text-gray-900"
}, "Token Mint Address", -1)

import {computed, reactive, ref, watch, watchEffect} from 'vue'
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue'
import ToggleSwitch from '@/components/ToggleSwitch.vue'
import { BN } from "@project-serum/anchor"
import {
  CalendarIcon,
  HomeIcon,
  MapIcon,
  MenuIcon,
  SpeakerphoneIcon,
  UserGroupIcon,
  XIcon,
    CashIcon
} from '@heroicons/vue/outline'
import {useAnchorWallet, useWallet, WalletMultiButton} from 'solana-wallets-vue'
import * as web3 from "@solana/web3.js";
import NetworkDropdown from "@/components/NetworkDropdown.vue"
import {
  GameWalletLib,
  GAME_WALLET_PROGRAM_ID
} from '@mirrorworld/library.wallet';
import { toast } from "@/utils/notifications";
import { IonToggle } from "@ionic/vue";
import {IGameWalletConfiguration} from "@/types/game-wallet";
import joi from 'joi'

//Navigation

export default /*#__PURE__*/_defineComponent({
  __name: 'TabsPage',
  setup(__props) {

const navigation = [
  { name: 'Game Wallet', href: '#', icon: CashIcon, current: true },
]
const sidebarOpen = ref(false)


// Solana connection
// const { wallet } = useWallet()
const wallet = useAnchorWallet()

const programIdRaw = ref("F78NhTC9XmP1DKsCBRz5LGdQc4n4yFbj2dURiv7T9gGZ")
const programId = computed(() => new web3.PublicKey(programIdRaw.value) || GAME_WALLET_PROGRAM_ID)

const tokenMintAddressRaw = ref("FM46MMivyNgcVQ56gsgrZLEY3qHhdYtNJQRrqfbkosCr")
const tokenMint = computed(() => new web3.PublicKey(tokenMintAddressRaw.value))

const toggle = ref(true)

const network = ref<"mainnet-beta" | "devnet">("mainnet-beta")
// const endpoint = computed(() => network.value === "devnet" ? "https://solana-devnet.mirrorworld.fun" : "https://solana-mainnet.mirrorworld.fun")
const endpoint = computed(() => network.value === "devnet" ? web3.clusterApiUrl("devnet") : web3.clusterApiUrl("mainnet-beta"))
const connection = computed((() => new web3.Connection(endpoint.value, "confirmed")))

const gameWallet = ref<GameWalletLib | null>(null)

watchEffect(async () => {
  if (programId.value && connection.value && wallet.value) {
    gameWallet.value = new GameWalletLib(
        programId.value,
        connection.value,
        // @ts-expect-error `payer` field not typed
        wallet.value!
    );

    console.debug("gameWallet initialized", gameWallet.value)
    console.debug("ProgramID:", programId.value.toBase58())

    Object.keys(gameWallet.value).forEach(console.log)
    await getGameWalletConfiguration()
  }
})

// @ts-expect-error Object is initialized to an empty object
const configuration = reactive<IGameWalletConfiguration>({})

async function getGameWalletConfiguration() {
  if (!gameWallet.value) throw new Error("Wallet not initialized")
  try {
    const config = await printConfig()

  } catch (e: any) {
    console.error(e)
    toast(e.message, undefined, {
      color: "danger"
    })
  }
}

const readOnlyProperties = ref<(keyof IGameWalletConfiguration)[]>([
    'signingAuthority',
    'tokenDecimal',
    'depositPool',
    'distributionPool',
    'distributionPool',
    'lastUsedBlockTimestamp',
    'tokenMintAccount'
])
const nonBigNumbers = ref<(keyof IGameWalletConfiguration)[]>([
    'maxWithdraw',
    'minWithdraw'
])

const mutableProperties = ref<(keyof IGameWalletConfiguration)[]>([
  'maxWithdraw',
  'minWithdraw',
  'isPaused',
  'canDeposit',
  'canSpend',
  'canDistribute',
  'canWithdraw',
  'isDistributionServiceFeeEnable',
  'isWithdrawServiceFeeEnable',
  'withdrawServiceFeePercentage',
  'incomeAccount'
])

console.log("LAMPORTS_PER_SOL", web3.LAMPORTS_PER_SOL)

async function printConfig() {
  if (!gameWallet.value) throw new Error("SDK not initialized")
  const [tokenConfigAccountPda] = await gameWallet.value.getTokenConfigAccountPdaAndBump(tokenMint.value);
  const config = await gameWallet.value.getTokenConfigAccountPdaData(tokenConfigAccountPda);
  const printed = Object.keys(config).reduce((acc, curr) => {
    const prop = config[curr];
    acc[curr] = typeof prop?.toBase58 !== 'undefined' ? prop.toBase58() : prop instanceof BN ?  prop.toNumber ? nonBigNumbers.value.includes(curr as keyof IGameWalletConfiguration) ? (prop.toNumber() / web3.LAMPORTS_PER_SOL) : prop.toNumber() : prop.toNumber() : prop;
    return acc;
  }, {} as Awaited<ReturnType<typeof gameWallet.value.getTokenConfigAccountPdaData>>) as IGameWalletConfiguration;

  console.log('Configuration', printed);
  Object.keys(printed as any as IGameWalletConfiguration).forEach((key) => {
    configuration[key] = printed[key]
  })
  return printed
}

const mutableConfigurationSchema = joi.object<IGameWalletConfiguration>({
  signingAuthority: joi.custom((value, helper) => {
    try {
      const pk = new web3.PublicKey(value)
      return true
    } catch (e: any) {
      return helper.message({
        message: "signingAuthority must be a valid public key"
      })
    }
  }),
  tokenMintAccount: joi.custom((value, helper) => {
    try {
      const pk = new web3.PublicKey(value)
      return true
    } catch (e: any) {
      return helper.message({
        message: "signingAuthority must be a valid public key"
      })
    }
  }),
  depositPool: joi.custom((value, helper) => {
    try {
      const pk = new web3.PublicKey(value)
      return true
    } catch (e: any) {
      return helper.message({
        message: "signingAuthority must be a valid public key"
      })
    }
  }),
  incomeAccount: joi.custom((value, helper) => {
    try {
      const pk = new web3.PublicKey(value)
      return true
    } catch (e: any) {
      return helper.message({
        message: "signingAuthority must be a valid public key"
      })
    }
  }),
  distributionPool: joi.custom((value, helper) => {
    try {
      const pk = new web3.PublicKey(value)
      return true
    } catch (e: any) {
      return helper.message({
        message: "signingAuthority must be a valid public key"
      })
    }
  }),
  tokenDecimal: joi.number(),
  withdrawServiceFeePercentage: joi.number().integer().min(0).max(100),
  spendServiceFeePercentage: joi.number().integer().min(0).max(100),
  distributionServiceFeePercentage: joi.number().integer().min(0).max(100),
  minWithdraw: joi.number(),
  maxWithdraw: joi.number(),
  isPaused: joi.boolean(),
  canDeposit: joi.boolean(),
  canWithdraw: joi.boolean(),
  canSpend: joi.boolean(),
  canDistribute: joi.boolean(),
  isWithdrawServiceFeeEnable: joi.boolean(),
  isSpendServiceFeeEnable: joi.boolean(),
  isDistributionServiceFeeEnable: joi.boolean(),
  isMinWithdrawEnable: joi.boolean(),
  isMaxWithdrawEnable: joi.boolean(),
})

watch(() => configuration, async (newVal, oldVal) => {
  //Return if this is the first time it is running
  if (Object.keys(oldVal).length < 1) return

  try {
    console.debug("config updated", newVal)
    delete newVal.lastUsedBlockTimestamp
    const isValid = mutableConfigurationSchema.validate(newVal)
    console.log("isValid", isValid)
  } catch (e: any) {
    toast(e.message, undefined, {
      color: "danger"
    })
    console.error(e)
  }
}, {
  deep: true
})



async function updateTokenConfiguration(params: Omit<IGameWalletConfiguration, "lastUsedBlockTimestamp">) {
  try {
    if (!gameWallet.value) throw new Error("SDK not initialized")

    console.log("params", params)

    console.log("Payload", [
      params.tokenDecimal,
      params.isPaused,
      params.canDeposit,
      params.canWithdraw,
      params.canSpend,
      params.canDistribute,
      params.isWithdrawServiceFeeEnable,
      params.withdrawServiceFeePercentage,
      params.isSpendServiceFeeEnable,
      params.spendServiceFeePercentage,
      params.isDistributionServiceFeeEnable,
      params.distributionServiceFeePercentage,
      params.isMinWithdrawEnable,
      params.isMaxWithdrawEnable,
      // Here we manually bind the LAMPORTS_PER_SOL because the
      // token wecurrently support is a 9-decimal token. In the future
      // in order to support other 6 decimal tokens like USDC, we may
      // need remove this.
      params.minWithdraw * web3.LAMPORTS_PER_SOL,
      params.maxWithdraw * web3.LAMPORTS_PER_SOL,
      wallet!.value!.publicKey!,
      new web3.PublicKey(params.signingAuthority),
      new web3.PublicKey(params.tokenMintAccount),
      new web3.PublicKey(params.incomeAccount)
    ])



    const createUpdateTokenConfigTransaction = await gameWallet.value.createUpdateTokenConfigTransaction(
        params.tokenDecimal,
        params.isPaused,
        params.canDeposit,
        params.canWithdraw,
        params.canSpend,
        params.canDistribute,
        params.isWithdrawServiceFeeEnable,
        params.withdrawServiceFeePercentage,
        params.isSpendServiceFeeEnable,
        params.spendServiceFeePercentage,
        params.isDistributionServiceFeeEnable,
        params.distributionServiceFeePercentage,
        params.isMinWithdrawEnable,
        params.isMaxWithdrawEnable,
        // Here we manually bind the LAMPORTS_PER_SOL because the
        // token wecurrently support is a 9-decimal token. In the future
        // in order to support other 6 decimal tokens like USDC, we may
        // need remove this.
        params.minWithdraw * web3.LAMPORTS_PER_SOL,
        params.maxWithdraw * web3.LAMPORTS_PER_SOL,
        wallet!.value!.publicKey!,
        new web3.PublicKey(params.signingAuthority),
        new web3.PublicKey(params.tokenMintAccount),
        new web3.PublicKey(params.incomeAccount)
    )

    console.log("createUpdateTokenConfigTransaction", createUpdateTokenConfigTransaction)

    let signed: web3.Transaction | undefined = undefined;

    try {
      signed = await wallet.value!.signTransaction(createUpdateTokenConfigTransaction);
    } catch (e: any) {
      console.error('Seller cancelled transaction', e);
      throw e;
    }

    let signature = undefined;
    let result: web3.RpcResponseAndContext<web3.SignatureResult>;
    try {
      signature = await connection.value.sendRawTransaction(signed!.serialize());
      result = await connection.value.confirmTransaction(signature, 'confirmed');
      console.log('result', result!)
      toast("🎉 Successfully updated token configuration", undefined, {
        color: "success"
      })
      return [result!, signature] as const;
    } catch (error: any) {
      console.error(error);
      toast(error.message, undefined, {
        color: "danger"
      })
      throw error
    }
  } catch (e: any) {
    toast(e.message, undefined, {
      color: "danger"
    })
    console.error(e)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: sidebarOpen.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-40 lg:hidden",
          onClose: _cache[1] || (_cache[1] = ($event: any) => (sidebarOpen.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "transition-opacity ease-linear duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "transition-opacity ease-linear duration-300",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "transition ease-in-out duration-300 transform",
                "enter-from": "-translate-x-full",
                "enter-to": "translate-x-0",
                leave: "transition ease-in-out duration-300 transform",
                "leave-from": "translate-x-0",
                "leave-to": "-translate-x-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), { class: "relative flex-1 flex flex-col max-w-xs w-full bg-white focus:outline-none" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TransitionChild), {
                        as: "template",
                        enter: "ease-in-out duration-300",
                        "enter-from": "opacity-0",
                        "enter-to": "opacity-100",
                        leave: "ease-in-out duration-300",
                        "leave-from": "opacity-100",
                        "leave-to": "opacity-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarOpen.value = false))
                            }, [
                              _hoisted_5,
                              _createVNode(_unref(XIcon), {
                                class: "h-6 w-6 text-white",
                                "aria-hidden": "true"
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("nav", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                              return _createElementVNode("a", {
                                key: item.name,
                                href: item.href,
                                class: _normalizeClass([item.current ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900', 'group flex items-center px-2 py-2 text-base font-medium rounded-md'])
                              }, [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                                  class: _normalizeClass([item.current ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500', 'mr-4 h-6 w-6']),
                                  "aria-hidden": "true"
                                }, null, 8, ["class"])),
                                _createTextVNode(" " + _toDisplayString(item.name), 1)
                              ], 10, _hoisted_10)
                            }), 64))
                          ])
                        ])
                      ]),
                      _hoisted_11
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_12
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("nav", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                  return _createElementVNode("a", {
                    key: item.name,
                    href: item.href,
                    class: _normalizeClass([item.current ? 'bg-gray-200 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900', 'group flex items-center px-2 py-2 text-sm font-medium rounded-md'])
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                      class: _normalizeClass([item.current ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500', 'mr-3 h-6 w-6']),
                      "aria-hidden": "true"
                    }, null, 8, ["class"])),
                    _createTextVNode(" " + _toDisplayString(item.name), 1)
                  ], 10, _hoisted_20)
                }), 64))
              ])
            ])
          ]),
          _hoisted_21
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_unref(WalletMultiButton)),
        _createVNode(NetworkDropdown, {
          modelValue: network.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((network).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              type: "button",
              class: "-mr-3 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (sidebarOpen.value = true))
            }, [
              _hoisted_27,
              _createVNode(_unref(MenuIcon), {
                class: "h-6 w-6",
                "aria-hidden": "true"
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("main", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              (Object.keys(configuration).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (updateTokenConfiguration(configuration))),
                      class: "inline-flex justify-center items-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    }, " Update configuration "),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(configuration), (prop) => {
                      return (_openBlock(), _createElementBlock("div", { key: prop }, [
                        _createElementVNode("code", _hoisted_33, _toDisplayString(prop), 1),
                        (typeof configuration[prop] === 'boolean')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass([readOnlyProperties.value.includes(prop) ? 'opacity-60': 'opacity-100', 'isolate -space-y-px rounded-md shadow-sm'])
                            }, [
                              _createVNode(_unref(IonToggle), {
                                modelValue: configuration[prop],
                                "onUpdate:modelValue": ($event: any) => ((configuration[prop]) = $event),
                                disabled: readOnlyProperties.value.includes(prop),
                                color: "primary"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(prop), 1)
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])
                            ], 2))
                          : _createCommentVNode("", true),
                        (typeof configuration[prop] === 'string')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass([readOnlyProperties.value.includes(prop) ? 'opacity-60': 'opacity-100', 'isolate -space-y-px rounded-md shadow-sm'])
                            }, [
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("label", _hoisted_35, _toDisplayString(prop), 1),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((configuration[prop]) = $event),
                                  disabled: readOnlyProperties.value.includes(prop),
                                  type: "text",
                                  name: "name",
                                  id: "name",
                                  class: "block w-full border-0 bg-white p-0 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-0 sm:text-sm"
                                }, null, 8, _hoisted_36), [
                                  [_vModelText, configuration[prop]]
                                ])
                              ])
                            ], 2))
                          : _createCommentVNode("", true),
                        (typeof configuration[prop] === 'number')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: _normalizeClass([readOnlyProperties.value.includes(prop) ? 'opacity-60': 'opacity-100', 'isolate -space-y-px rounded-md shadow-sm'])
                            }, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("label", _hoisted_38, _toDisplayString(prop), 1),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((configuration[prop]) = $event),
                                  disabled: readOnlyProperties.value.includes(prop),
                                  type: "number",
                                  name: "name",
                                  id: "name",
                                  class: "block w-full border-0 bg-white p-0 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-0 sm:text-sm"
                                }, null, 8, _hoisted_39), [
                                  [_vModelText, configuration[prop]]
                                ])
                              ])
                            ], 2))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("aside", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((programIdRaw).value = $event)),
                      type: "text",
                      name: "name",
                      id: "name",
                      class: "block w-full border-0 bg-white p-0 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-0 sm:text-sm",
                      placeholder: "8EiozskbhZ7Y9a5gxJQbNvuDtbabchg2YhYDWanKBXs2"
                    }, null, 512), [
                      [_vModelText, programIdRaw.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((tokenMintAddressRaw).value = $event)),
                      type: "text",
                      name: "name",
                      id: "name",
                      class: "block w-full border-0 bg-white p-0 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-0 sm:text-sm",
                      placeholder: "BvrranCddgP1VZs7qnKt8wRdGDuM7MxYPCytDmT76E51"
                    }, null, 512), [
                      [_vModelText, tokenMintAddressRaw.value]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: getGameWalletConfiguration,
                class: "inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              }, " Load config ")
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})